<nav
  [@animateMenu]
  class="navbar main-navbar on-top"
  [class.nav-shadow]="this.pageYPosition > 0"
>
  <div class="container">
    <a class="navbar-brand text-light">
      <img src="assets/images/logo.png" width="250" />
    </a>
    <ul ngbNav #nav="ngbNav" class="menu-ul">
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('about')"
          ><span class="nav-number">01. </span>
          <span class="underline nav-text"> About Me</span></a
        >
      </li>
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('jobs')"
          ><span class="nav-number">02. </span>
          <span class="underline nav-text"> Experience</span></a
        >
      </li>
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('projects')"
          ><span class="nav-number">03. </span>
          <span class="underline nav-text"> Projects</span></a
        >
      </li>
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('skills')"
          ><span class="nav-number">04. </span>
          <span class="underline nav-text"> Skills</span></a
        >
      </li>
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('contact')"
          ><span class="nav-number">05. </span>
          <span class="underline nav-text"> Contact</span></a
        >
      </li>
      <li ngbNavItem>
        <a (click)="downloadCV()" class="main-btn cv-btn" ngbNavLink>
          Resume
        </a>
      </li>
    </ul>
    <div class="menu-wrapper">
      <div
        [class.animate]="responsiveMenuVisible"
        (click)="responsiveMenuVisible = !responsiveMenuVisible"
        class="hamburger-menu"
      ></div>
    </div>
    <div
      class="menu-responsive"
      [ngStyle]="{ 'pointer-events': !responsiveMenuVisible ? 'none' : '' }"
    >
      <aside
        [class.aside-show]="responsiveMenuVisible"
        [class.nav-shadow]="this.pageYPosition > 0"
        class="on-top"
      >
        <nav>
          <ol>
            <li>
              <a (click)="scroll('about')"> <span>01. </span> About Me </a>
            </li>
            <li>
              <a (click)="scroll('jobs')"> <span>02. </span> Experience </a>
            </li>
            <li>
              <a (click)="scroll('projects')"> <span>03. </span> Projects </a>
            </li>
            <li>
              <a (click)="scroll('skills')"> <span>04. </span> Skills </a>
            </li>
            <li>
              <a (click)="scroll('contact')"> <span>05. </span> Contact </a>
            </li>
            <li>
              <a (click)="downloadCV()" class="main-btn cv-btn"> Resume </a>
            </li>
          </ol>
        </nav>
      </aside>
    </div>
  </div>
</nav>
